import { SelectorPair } from '../types'
import { stepPrerequisites } from '../dependencies'
import { isElementReady } from './elementUtils'

const findAndUseReactContext = (
  contextName: string,
  callback: (context: any) => boolean
): boolean => {
  try {
    const allElements = document.querySelectorAll('body *')
    for (const element of Array.from(allElements)) {
      const fiberKey = Object.keys(element).find((key) => key.startsWith('__reactFiber$'))
      if (!fiberKey) continue

      let fiber = (element as any)[fiberKey]
      while (fiber) {
        if (fiber.type?._context?.displayName?.includes(contextName)) {
          const context = fiber.memoizedProps?.value
          if (context && callback(context)) return true
        }
        fiber = fiber.return
      }
    }
    return false
  } catch (error) {
    return false
  }
}

export const openBacktestSidebarDirectly = (): Promise<boolean> =>
  new Promise((resolve) => {
    const success = findAndUseReactContext('ShowcaseContext', (context: any) => {
      if (typeof context?.setFocusedBacktest === 'function') {
        context.setFocusedBacktest({ id: 'demo-backtest' })
        return true
      }
      return false
    })
    resolve(success)
  })

export const openBacktestRunDialogDirectly = (): Promise<boolean> =>
  new Promise((resolve) => {
    const success = findAndUseReactContext('ModalContext', (context: any) => {
      if (typeof context?.setIsBacktestRunDialogOpen === 'function') {
        context.setIsBacktestRunDialogOpen(true)
        return true
      }
      return false
    })
    resolve(success)
  })

export const openAlertSidebarDirectly = (): Promise<boolean> =>
  new Promise((resolve) => {
    const success = findAndUseReactContext('AlertContext', (context: any) => {
      if (typeof context?.setIsAlertSidePanelOpen === 'function') {
        context.setIsAlertSidePanelOpen(true)
        return true
      }
      return false
    })
    resolve(success)
  })

export const openDependencyDirectly = async (dependency: SelectorPair): Promise<boolean> => {
  if (isElementReady(dependency.selector)) {
    return true
  }

  if (dependency === stepPrerequisites.backtestSideNav) {
    return await openBacktestSidebarDirectly()
  } else if (dependency === stepPrerequisites.rerunDialog) {
    return await openBacktestRunDialogDirectly()
  } else if (dependency === stepPrerequisites.alertSideNav) {
    return await openAlertSidebarDirectly()
  } else {
    const btn = document.querySelector<HTMLButtonElement>(dependency.button)
    if (btn) {
      btn.click()
      return true
    }
    return false
  }
}
